<ng-container *transloco="let convert;">
  <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
    <app-modal [modalId]="modalId">
      <div class="modal__content">
        <div class="modal__body">
          <div class="modal__section">
            @if (!isError) {
              <i class="allycon-checkmark indicator-success" aria-hidden="true"></i>
            }
            @if (isError) {
              <i class="allycon-error-fill text-danger" aria-hidden="true"></i>
            }
            @if (isAuthorized) {
              <p data-test-id="ambassador-response-modal-body-authorized-message">
                {{ convert('ambassadorAuthorization.modal.successAuthorized') }} {{ name }}.
              </p>
            }
            @if (isRemoved) {
              <p data-test-id="ambassador-response-modal-body-removed-message">
                {{ convert('ambassadorAuthorization.modal.successRemoved') }} {{ name }}.
              </p>
            }
            @if (isError) {
              <p data-test-id="ambassador-response-modal-body-error-message">
                {{ convert('ambassadorAuthorization.modal.error') }}
              </p>
            }
          </div>
          <div class="modal__actions mt-4 text-center">
            <button
              data-test-id="ambassador-response-modal-actions-close-button"
              class="btn btn-primary cancel-btn me-md-2 mb-3 mb-md-0"
              (click)="close()"
              allytmln="responseModalClose"
              >
              {{ convert('common.btnClose') }}
            </button>
          </div>
        </div>
      </div>

      <div class="modal-close-container">
        <button
          data-test-id="ambassador-response-modal-header-close-button"
          id="close_x_button"
          class="modal__close-btn"
          [attr.aria-label]="convert('common.modalClose')"
          allytmln="responseModalClose"
          data-micromodal-close
          (click)="close()"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </app-modal>
  </trap-focus>
</ng-container>
